import type { UnitTypes } from 'unitData/types';
import type { AddUnitDataInterface } from './sagaActions';
import type { UnitInterface } from './types';
import { getUnitConfig } from './unitRegistry';

export const setDefaultUnitValues = (
  unit: UnitInterface,
  category: string,
  unitInfoData: AddUnitDataInterface,
): UnitInterface => {
  const config = getUnitConfig(category as UnitTypes);

  const unitInfo = config.getDefaultData({
    data: unitInfoData as Record<string, unknown>,
    variantId: unit.layout?.variantId,
    unitType: category,
  });

  return {
    ...unit,
    unitInfo,
  };
};
